export default "__VITE_ASSET__ec16bbe6__"